// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","ServicePhone":"Footer_ServicePhone__2HCMt","PhoneIconLink":"Footer_PhoneIconLink__2LEZr","AccoladeLogo":"Footer_AccoladeLogo__1K7TS"};